import React from "react";
import { Region } from "../Region";

type InsuranceWithBillingRegionsProps = {
  billingPayment: React.ReactNode;
  insurance: React.ReactNode;
};

export const InsuranceWithBillingRegions = ({
  billingPayment,
  insurance,
}: InsuranceWithBillingRegionsProps) => {
  return (
    <>
      {billingPayment && (
        <Region
          title="Billing and Payment"
          contentSlot={billingPayment}
          hash="billing"
        />
      )}
      {insurance}
    </>
  );
};
